export const StationSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
    >
      <g clip-path="url(#clip0_61_275)">
        <circle cx="26" cy="26" r="26" fill="#ABD1C6" fill-opacity="0.25" />
        <path
          d="M16.4 38.2C15.74 38.2 15.1748 37.9648 14.7044 37.4944C14.234 37.024 13.9992 36.4592 14 35.8V21.4C14 20.9 14.1352 20.45 14.4056 20.05C14.676 19.65 15.0408 19.36 15.5 19.18L30.68 13L31.46 14.98L21.56 19H35.6C36.26 19 36.8252 19.2352 37.2956 19.7056C37.766 20.176 38.0008 20.7408 38 21.4V35.8C38 36.46 37.7648 37.0252 37.2944 37.4956C36.824 37.966 36.2592 38.2008 35.6 38.2H16.4ZM16.4 35.8H35.6V27.4H16.4V35.8ZM21.2 34.6C22.04 34.6 22.75 34.31 23.33 33.73C23.91 33.15 24.2 32.44 24.2 31.6C24.2 30.76 23.91 30.05 23.33 29.47C22.75 28.89 22.04 28.6 21.2 28.6C20.36 28.6 19.65 28.89 19.07 29.47C18.49 30.05 18.2 30.76 18.2 31.6C18.2 32.44 18.49 33.15 19.07 33.73C19.65 34.31 20.36 34.6 21.2 34.6ZM16.4 25H30.8V22.6H33.2V25H35.6V21.4H16.4V25Z"
          fill="#004643"
        />
      </g>
      <defs>
        <clipPath id="clip0_61_275">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdVisitSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
    >
      <g clip-path="url(#clip0_61_284)">
        <circle cx="26" cy="26" r="26" fill="#ABD1C6" fill-opacity="0.25" />
        <path
          d="M13 26C13 27.7072 13.3363 29.3977 13.9896 30.9749C14.6429 32.5521 15.6004 33.9852 16.8076 35.1924C18.0148 36.3995 19.4479 37.3571 21.0251 38.0104C22.6023 38.6637 24.2928 39 26 39C27.7072 39 29.3977 38.6637 30.9749 38.0104C32.5521 37.3571 33.9852 36.3995 35.1924 35.1924C36.3995 33.9852 37.3571 32.5521 38.0104 30.9749C38.6637 29.3977 39 27.7072 39 26C39 24.2928 38.6637 22.6023 38.0104 21.0251C37.3571 19.4479 36.3995 18.0148 35.1924 16.8076C33.9852 15.6005 32.5521 14.6429 30.9749 13.9896C29.3977 13.3363 27.7072 13 26 13C24.2928 13 22.6023 13.3363 21.0251 13.9896C19.4479 14.6429 18.0148 15.6005 16.8076 16.8076C15.6004 18.0148 14.6429 19.4479 13.9896 21.0251C13.3363 22.6023 13 24.2928 13 26Z"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.2207 26C20.2207 29.4478 20.8294 32.7544 21.913 35.1924C22.9965 37.6304 24.4661 39 25.9985 39C27.5308 39 29.0004 37.6304 30.084 35.1924C31.1675 32.7544 31.7763 29.4478 31.7763 26C31.7763 22.5522 31.1675 19.2456 30.084 16.8076C29.0004 14.3696 27.5308 13 25.9985 13C24.4661 13 22.9965 14.3696 21.913 16.8076C20.8294 19.2456 20.2207 22.5522 20.2207 26Z"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 25.9999C13 29.1922 18.8211 31.7777 26 31.7777C33.1789 31.7777 39 29.1922 39 25.9999C39 22.8077 33.1789 20.2222 26 20.2222C18.8211 20.2222 13 22.8077 13 25.9999Z"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_61_284">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AdImpact = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
    >
      <g clip-path="url(#clip0_61_296)">
        <circle cx="26" cy="26" r="26" fill="#ABD1C6" fill-opacity="0.25" />
        <path
          d="M38.9997 19.4999L25.9999 13L13 19.4999V32.4998L25.9999 38.9997L38.9997 32.4998V19.4999Z"
          stroke="#004643"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M13 19.5L25.9999 25.9999"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26 38.9999V26"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M39.0001 19.5L26.0002 25.9999"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.4999 16.25L19.5 22.7499"
          stroke="#004643"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_61_296">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TotalSpend = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
    >
      <g clip-path="url(#clip0_61_310)">
        <circle cx="26" cy="26" r="26" fill="#ABD1C6" fill-opacity="0.25" />
        <path
          d="M31 30.6667C31 29.1933 26.8213 28 21.6667 28M31 30.6667C31 32.14 26.8213 33.3333 21.6667 33.3333C16.512 33.3333 12.3333 32.14 12.3333 30.6667M31 30.6667V37.2493C31 38.768 26.8213 40 21.6667 40C16.512 40 12.3333 38.7693 12.3333 37.2493V30.6667M31 30.6667C36.0987 30.6667 40.3333 29.3507 40.3333 28V14.6667M21.6667 28C16.512 28 12.3333 29.1933 12.3333 30.6667M21.6667 28C15.776 28 11 26.684 11 25.3333V18.6667M21.6667 16C15.776 16 11 17.1933 11 18.6667M11 18.6667C11 20.14 15.776 21.3333 21.6667 21.3333C21.6667 22.684 26.004 24 31.1027 24C36.2 24 40.3333 22.684 40.3333 21.3333M40.3333 14.6667C40.3333 13.1933 36.2 12 31.1027 12C26.004 12 21.872 13.1933 21.872 14.6667M40.3333 14.6667C40.3333 16.14 36.2 17.3333 31.1027 17.3333C26.0053 17.3333 21.872 16.14 21.872 14.6667M21.872 14.6667V28.2213"
          stroke="#004643"
          stroke-width="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_61_310">
          <rect width="52" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MoneySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="52"
      height="52"
      x="0"
      y="0"
      viewBox="0 0 52 52"
    >
      <g clip-path="url(#clip0_61_275)">
        <circle cx="26" cy="26" r="26" fill="#ABD1C6" fill-opacity="0.25" />
        <g transform="translate(14,14)">
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill="#004643"
            fill-rule="evenodd"
            d="M12 3.75a8.25 8.25 0 1 0 7.885 5.815.75.75 0 0 1 1.433-.442c.281.91.432 1.877.432 2.877 0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25c.69 0 1.366.072 2.018.21a.75.75 0 0 1-.31 1.467A8.287 8.287 0 0 0 12 3.75zm6.958-1.119a.75.75 0 0 1 1.06.042l1.85 2a.75.75 0 0 1 0 1.018l-1.85 2a.75.75 0 0 1-1.101-1.018l.685-.74h-3.284a.75.75 0 0 1 0-1.5h3.284l-.685-.742a.75.75 0 0 1 .041-1.06zM12 5.25a.75.75 0 0 1 .75.75v1.272h.027a2.786 2.786 0 0 1 2.785 2.786.75.75 0 1 1-1.5 0c0-.71-.575-1.286-1.285-1.286h-.027v2.491h.08a2.732 2.732 0 1 1 0 5.465h-.08V18a.75.75 0 0 1-1.5 0v-1.272h-.08a2.732 2.732 0 0 1-2.733-2.733.75.75 0 0 1 1.5 0c0 .681.552 1.233 1.233 1.233h.08v-2.465h-.067a2.746 2.746 0 0 1 0-5.49h.067V6a.75.75 0 0 1 .75-.75zm-.75 3.522h-.067a1.246 1.246 0 0 0 0 2.491h.067zm1.5 3.991v2.465h.08a1.232 1.232 0 0 0 0-2.465z"
            clip-rule="evenodd"
            opacity="1"
            data-original="#000000"
            class=""
          />
        </g>
      </g>
    </svg>
  );
};
export const PlaySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="52"
      height="52"
      x="0"
      y="0"
      viewBox="0 0 52 52"
    >
      <g>
        <circle cx="26" cy="26" r="24" fill="#ABD1C6" fillOpacity="0.25" />
        <g transform="translate(14, 14)">
          <circle
            cx="12"
            cy="12"
            r="12"
            stroke="#004643"
            strokeWidth="2"
            fillOpacity="0"
          />
          <path d="M9,6 L9,18 L18,12 L9,6 Z" fill="#004643" />
        </g>
      </g>
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74913 2.5C7.74913 2.30109 7.67011 2.11032 7.52946 1.96967C7.3888 1.82902 7.19804 1.75 6.99913 1.75C6.80021 1.75 6.60945 1.82902 6.46879 1.96967C6.32814 2.11032 6.24913 2.30109 6.24913 2.5V4.08C4.80912 4.195 3.86512 4.477 3.17112 5.172C2.47612 5.866 2.19412 6.811 2.07812 8.25H21.9201C21.8041 6.81 21.5221 5.866 20.8271 5.172C20.1331 4.477 19.1881 4.195 17.7491 4.079V2.5C17.7491 2.30109 17.6701 2.11032 17.5295 1.96967C17.3888 1.82902 17.198 1.75 16.9991 1.75C16.8002 1.75 16.6094 1.82902 16.4688 1.96967C16.3281 2.11032 16.2491 2.30109 16.2491 2.5V4.013C15.5841 4 14.8381 4 13.9991 4H9.99913C9.16012 4 8.41412 4 7.74913 4.013V2.5Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 12C2 11.161 2 10.415 2.013 9.75H21.987C22 10.415 22 11.161 22 12V14C22 17.771 22 19.657 20.828 20.828C19.657 22 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2 19.657 2 17.771 2 14V12ZM17 14C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13C16 13.2652 16.1054 13.5196 16.2929 13.7071C16.4804 13.8946 16.7348 14 17 14ZM17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17C18 16.7348 17.8946 16.4804 17.7071 16.2929C17.5196 16.1054 17.2652 16 17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM7 14C7.26522 14 7.51957 13.8946 7.70711 13.7071C7.89464 13.5196 8 13.2652 8 13C8 12.7348 7.89464 12.4804 7.70711 12.2929C7.51957 12.1054 7.26522 12 7 12C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18Z"
        fill="black"
      />
    </svg>
  );
};
export const CompletedSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_54_221)">
        <path
          d="M12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24ZM10.8036 16.8L19.2876 8.3148L17.592 6.618L10.8036 13.4064L7.4088 10.0116L5.712 11.7084L10.8036 16.8Z"
          fill="#005E59"
        />
      </g>
      <defs>
        <clipPath id="clip0_54_221">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FileSvg = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3524 11.4478C27.2892 11.3031 27.2007 11.1708 27.0911 11.0572L19.0911 3.05717C18.9774 2.94755 18.8451 2.85905 18.7004 2.79584C18.6604 2.77717 18.6178 2.7665 18.5751 2.75184C18.4635 2.71387 18.3474 2.691 18.2298 2.68384C18.2018 2.68117 18.1764 2.6665 18.1484 2.6665H8.8151C7.34444 2.6665 6.14844 3.8625 6.14844 5.33317V26.6665C6.14844 28.1372 7.34444 29.3332 8.8151 29.3332H24.8151C26.2858 29.3332 27.4818 28.1372 27.4818 26.6665V11.9998C27.4818 11.9718 27.4671 11.9465 27.4644 11.9172C27.4579 11.7995 27.435 11.6832 27.3964 11.5718C27.3831 11.5292 27.3711 11.4878 27.3524 11.4478ZM22.9298 10.6665H19.4818V7.2185L22.9298 10.6665ZM8.8151 26.6665V5.33317H16.8151V11.9998C16.8151 12.3535 16.9556 12.6926 17.2056 12.9426C17.4557 13.1927 17.7948 13.3332 18.1484 13.3332H24.8151L24.8178 26.6665H8.8151Z"
        fill="#0F3433"
      />
      <path
        d="M11.4805 15.9998H22.1471V18.6665H11.4805V15.9998ZM11.4805 21.3332H22.1471V23.9998H11.4805V21.3332ZM11.4805 10.6665H14.1471V13.3332H11.4805V10.6665Z"
        fill="#0F3433"
      />
    </svg>
  );
};
export const DownloadSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z" fill="#004643" />
    </svg>
  );
};
